// extracted by mini-css-extract-plugin
module.exports = {"mustTryPois":"components-TasteInfo-MustTryPois-MustTryPois__mustTryPois--MRGbF","mustTryPoisList":"components-TasteInfo-MustTryPois-MustTryPois__mustTryPoisList--AsVqK"};